import { ButtonBS, colors, Flex, RadioGroup, Text, VStack } from "@biblioteksentralen/react";
import { useState } from "react";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { SanityImagePreservingAspectRatio } from "../../images/SanityImagePreservingAspectRatio";
import { CalendarDoorElement } from "./types";

export const QuizWithAlternatives: CalendarDoorElement<"adventCalendarDoorQuizWithAlternatives"> = ({
  door,
  setAnswered,
}) => {
  const { t, ts } = useTranslation();
  const [chosenAlternativeIdx, setChosenAlternativeIdx] = useState<string | undefined>(undefined);

  const handleAnswer = () => {
    if (!door.alternatives || !chosenAlternativeIdx) {
      console.error("Something went wrong when answering advent calendar quiz", door._key);
      return;
    }

    setAnswered(door.alternatives[Number(chosenAlternativeIdx)]?.solution);
  };

  return (
    <VStack gap="1rem" alignItems="flex-start">
      {door.image?.asset && (
        <Flex
          justifyContent="center"
          width="100%"
          position="relative"
          marginBottom={door.image?.creator ? "0.5rem" : undefined}
        >
          <SanityImagePreservingAspectRatio resolution={350} image={door.image} borderRadius="sm" boxShadow="none" />
        </Flex>
      )}
      <Text fontSize={{ base: "lg", md: "xl" }} fontWeight={600}>
        {ts(door.question)}
      </Text>
      {!!door.alternatives?.length && (
        <RadioGroup.Root
          as="fieldset"
          onValueChange={({ value }) => setChosenAlternativeIdx(value ? value : undefined)}
          value={chosenAlternativeIdx}
          marginTop="0!important"
          _checked={{ background: colors.black, borderColor: colors.black }}
        >
          <VStack alignItems="flex-start">
            {door.alternatives?.map((alternative, idx) => (
              <RadioGroup.Item key={idx} value={idx.toString()}>
                <RadioGroup.ItemHiddenInput />
                <RadioGroup.ItemIndicator />
                <RadioGroup.ItemText>{ts(alternative?.text)}</RadioGroup.ItemText>
              </RadioGroup.Item>
            ))}
          </VStack>
        </RadioGroup.Root>
      )}
      <ButtonBS onClick={handleAnswer} disabled={typeof chosenAlternativeIdx === "undefined"}>
        {t("Sjekk svaret")}
      </ButtonBS>
    </VStack>
  );
};
